module.exports = __webpack_public_path__ + "img/etc.b84b962f.svg";